export const SalesDetailsTableHeader = [
  {
    field: 'saleId',
    headerName: 'Sale ID',
    width: 120,
  },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 150,
  },
  {
    field: 'name',
    headerName: 'Student Name',
    width: 200,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 220,
  },
  {
    field: 'courseName',
    headerName: 'Course',
    width: 200,
  },
  {
    field: 'projectName',
    headerName: 'Project',
    width: 150,
  },
  {
    field: 'levels',
    headerName: 'Level',
    width: 120,
  },
  {
    field: 'enrollmentDate',
    headerName: 'Enrollment Date',
    width: 200,
  },
  {
    field: 'salesAmount',
    headerName: 'Sales Amount',
    width: 150,
  },
  {
    field: 'paidAmount',
    headerName: 'Paid Amount',
    width: 150,
  },
  {
    field: 'pendingAmount',
    headerName: 'Pending Amount',
    width: 160,
  },
  {
    field: 'firstPaymentDate',
    headerName: 'First Payment Date',
    width: 180,
  },
  {
    field: 'ogaName',
    headerName: 'OGA Name',
    width: 180,
  },
  {
    field: 'croName',
    headerName: 'CRO Name',
    width: 180,
  },
  {
    field: 'completedSessions',
    headerName: 'Sessions Completed',
    width: 180,
  },
  {
    field: 'tutorReplacementCount',
    headerName: 'Tutor Replacements',
    width: 180,
  },
  //   {
  //     field: 'status',
  //     headerName: 'Status',
  //     width: 130,
  //     renderCell: ({ value }) => (
  //       <Chip label={value === 1 ? 'Active' : 'Inactive'} color={value === 1 ? 'success' : 'error'} />
  //     ),
  //   },
];
